import { Component } from 'react';

export default class PhoneBoothFilledIcon extends Component {
    render() {
        return (
            <svg width="interit" height="interit" viewBox="0 0 16 16" fill="interit" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.3334 15.0807L10.986 10.5507C10.9807 10.5533 9.67002 11.1973 9.61002 11.2247C8.11669 11.9487 5.07736 6.01133 6.53736 5.22867L7.92602 4.54467L5.59736 0L4.19336 0.692667C-0.607975 3.196 7.01536 18.014 11.9267 15.7693C12.0074 15.7327 13.328 15.0833 13.3334 15.0807Z" fill="interit"/>
            </svg>

        )
    }
};